/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {IHeaderAngularComp} from 'ag-grid-angular';
import {IHeaderParams} from 'ag-grid-community';

/**
 * Custom AG Grid header component for the Catena-X assets column.
 * Renders the CX logo alongside the column label text.
 */
@Component({
  selector: 'app-cx-column-header',
  standalone: true,
  template: `
    <div class="cx-header">
      <img src="assets/img/cx-logo.png" alt="cx-logo" width="18" height="18" />
      <span class="ag-header-cell-text">{{ label() }}</span>
    </div>
  `,
  styles: [
    `
      .cx-header {
        display: flex;
        align-items: center;
        gap: 6px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CxColumnHeaderComponent implements IHeaderAngularComp {
  readonly label = signal('');

  agInit(params: IHeaderParams): void {
    this.label.set(params.displayName);
  }

  refresh(params: IHeaderParams): boolean {
    this.label.set(params.displayName);
    return true;
  }
}
